// Module
var code = `<div class="content-block"> <div class="container-fluid no-gutters"> <div> <p class="text-align-center"> <strong>Perito IBP {{this.appVersion}}</strong> </p> </div> <div style="height:10px"></div> <app-license-component></app-license-component> </div> </div>`;
// Exports
export default code;